"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontMap = void 0;
exports.fontMap = {
    "fonipa": [
        "Charis SIL",
        "Doulos SIL"
    ],
    "Adlm": [
        "Ebrima",
        "NotoSansAdlam"
    ],
    "Aghb": [
        "NotoSansCaucasianAlbanian"
    ],
    "Ahom": [
        "NotoSerifAhom"
    ],
    "Arab-CM": [
        "Harmattan"
    ],
    "Arab-GN": [
        "Harmattan"
    ],
    "Arab-SN": [
        "Harmattan"
    ],
    "Arab-NG": [
        "Harmattan"
    ],
    "Arab-NE": [
        "Harmattan"
    ],
    "Arab-PK": [
        "Awami Nastaliq"
    ],
    "Arab": [
        "Scheherazade",
        "NotoSansArabic"
    ],
    "Aran": [
        "Awami Nastaliq",
        "NotoNastaliqUrdu"
    ],
    "Armi": [
        "NotoSansImperialAramaic"
    ],
    "Armn": [
        "NotoSansArmenian",
        "NotoSerifArmenian"
    ],
    "Avst": [
        "NotoSansAvestan"
    ],
    "Bali": [
        "NotoSansBalinese"
    ],
    "Bamu": [
        "NotoSansBamum"
    ],
    "Bass": [
        "NotoSansBassaVah"
    ],
    "Batk": [
        "NotoSansBatak"
    ],
    "Beng": [
        "NotoSansBengali",
        "NotoSerifBengali"
    ],
    "Bhks": [
        "NotoSansBhaiksuki"
    ],
    "Brah": [
        "NotoSansBrahmi"
    ],
    "Bugi": [
        "NotoSansBuginese"
    ],
    "Buhd": [
        "NotoSansBuhid"
    ],
    "Cakm": [
        "NotoSansChakma"
    ],
    "Cans": [
        "NotoSansCanadianAboriginal"
    ],
    "Cari": [
        "NotoSansCarian"
    ],
    "Cham": [
        "NotoSansCham"
    ],
    "Cher": [
        "NotoSansCherokee"
    ],
    "Copt": [
        "NotoSansCoptic",
        "Sophia Nubian"
    ],
    "Cprt": [
        "NotoSansCypriot"
    ],
    "Cyrl": [
        "Charis SIL",
        "NotoSansLatin",
        "NotoSerifLatin"
    ],
    "Deva": [
        "Annapurna SIL",
        "NotoSansDevanagari",
        "NotoSerifDevanagari"
    ],
    "Dsrt": [
        "NotoSansDeseret"
    ],
    "Dupl": [
        "NotoSansDuployan"
    ],
    "Egyp": [
        "NotoSansEgyptianHieroglyphs"
    ],
    "Elba": [
        "NotoSansElbasan"
    ],
    "Ethi": [
        "Abyssinica SIL",
        "NotoSansEthiopic",
        "NotoSerifEthiopic"
    ],
    "Geor": [
        "NotoSansGeorgian",
        "NotoSerifGeorgian"
    ],
    "Glag": [
        "NotoSansGlagolitic"
    ],
    "Gong": [
        "Narnoor"
    ],
    "Goth": [
        "NotoSansGothic"
    ],
    "Gran": [
        "NotoSansGrantha"
    ],
    "Grek": [
        "Gentium Plus",
        "NotoSansLatin",
        "NotoSerifLatin"
    ],
    "Gujr": [
        "NotoSansGujarati",
        "NotoSerifGujarati"
    ],
    "Guru": [
        "NotoSansGurmukhi",
        "NotoSerifGurmukhi"
    ],
    "Hanb": [
        "Noto Sans CJK SC",
        "Noto Serif CJK SC"
    ],
    "Hang": [
        "Noto Sans CJK KR",
        "Noto Serif CJK KR"
    ],
    "Hani": [
        "Noto Sans CJK JP",
        "Noto Serif CJK JP"
    ],
    "Hano": [
        "NotoSansHanunoo"
    ],
    "Hans": [
        "Noto Sans CJK SC",
        "Noto Serif CJK SC"
    ],
    "Hant": [
        "Noto Sans CJK TC",
        "Noto Serif CJK TC"
    ],
    "Hatr": [
        "NotoSansHatran"
    ],
    "Hebr": [
        "Ezra SIL",
        "NotoSansHebrew",
        "NotoSerifHebrew"
    ],
    "Hira": [
        "Noto Sans CJK JP",
        "Noto Serif CJK JP"
    ],
    "Hluw": [
        "NotoSansAnatolianHieroglyphs"
    ],
    "Hmng": [
        "NotoSansPahawhHmong"
    ],
    "Hrkt": [
        "Noto Sans CJK JP",
        "Noto Serif CJK JP"
    ],
    "Hung": [
        "NotoSansOldHungarian"
    ],
    "Ital": [
        "NotoSansOldItalic"
    ],
    "Jamo": [
        "Noto Sans CJK KR",
        "Noto Serif CJK KR"
    ],
    "Java": [
        "NotoSansJavanese"
    ],
    "Jpan": [
        "Noto Sans CJK JP",
        "Noto Serif CJK JP"
    ],
    "Kali": [
        "Kyebogyi",
        "Kayahli",
        "NotoSansKayah Li"
    ],
    "Kana": [
        "Noto Sans CJK JP",
        "Noto Serif CJK JP"
    ],
    "Khar": [
        "NotoSansKharoshthi"
    ],
    "Khmr": [
        "Khmer Mondulkiri",
        "NotoSansKhmer",
        "NotoSerifKhmer"
    ],
    "Khoj": [
        "NotoSansKhojki"
    ],
    "Knda": [
        "KNDA Badami",
        "NotoSansKannada",
        "NotoSerifKannada"
    ],
    "Kore": [
        "Noto Sans CJK KR",
        "Noto Serif CJK KR"
    ],
    "Kthi": [
        "NotoSansKaithi"
    ],
    "Lana": [
        "NotoSansTaiTham"
    ],
    "Laoo": [
        "DokChampa",
        "Saysettha MX",
        "NotoSansLao",
        "NotoSerifLao"
    ],
    "Latn": [
        "Charis SIL",
        "NotoSansLatin",
        "NotoSerifLatin"
    ],
    "Leke": [
        "NotoSansLeke"
    ],
    "Lepc": [
        "Mingzat",
        "NotoSansLepcha"
    ],
    "Limb": [
        "Namdhinggo SIL",
        "NotoSansLimbu"
    ],
    "Lina": [
        "NotoSansLinearA"
    ],
    "Linb": [
        "NotoSansLinearB"
    ],
    "Lisu": [
        "LisuTzimu",
        "NotoSansLisu"
    ],
    "Lyci": [
        "NotoSansLycian"
    ],
    "Lydi": [
        "NotoSansLydian"
    ],
    "Mahj": [
        "NotoSansMahajani"
    ],
    "Mand": [
        "NotoSansMandaic"
    ],
    "Mani": [
        "NotoSansManichaean"
    ],
    "Marc": [
        "NotoSansMarchen"
    ],
    "Mend": [
        "NotoSansMendeKikakui"
    ],
    "Merc": [
        "NotoSansMeroitic Cursive"
    ],
    "Mero": [
        "NotoSansMeroitic"
    ],
    "Mlym": [
        "NotoSansMalayalam",
        "NotoSerifMalayalam"
    ],
    "Modi": [
        "NotoSansModi"
    ],
    "Mong": [
        "NotoSansMongolian"
    ],
    "Mroo": [
        "NotoSansMro"
    ],
    "Mtei": [
        "NotoSansMeeteiMayek"
    ],
    "Mult": [
        "NotoSansMultani"
    ],
    "Mymr": [
        "Padauk",
        "NotoSansMyanmar",
        "NotoSerifMyanmar"
    ],
    "Nand": [
        "NotoSansNandinagari"
    ],
    "Narb": [
        "NotoSansOldNorthArabian"
    ],
    "Nbat": [
        "NotoSansNabataean"
    ],
    "Newa": [
        "NotoSansNewa"
    ],
    "Nkoo": [
        "Ebrima",
        "NotoSansNKo"
    ],
    "Ogam": [
        "NotoSansOgham"
    ],
    "Olck": [
        "NotoSansOl Chiki"
    ],
    "Orkh": [
        "NotoSansOldTurkic"
    ],
    "Orya": [
        "NotoSansOriya"
    ],
    "Osge": [
        "NotoSansOsage"
    ],
    "Osma": [
        "Ebrima",
        "NotoSansOsmanya"
    ],
    "Palm": [
        "NotoSansPalmyrene"
    ],
    "Pauc": [
        "NotoSansPauCinHau"
    ],
    "Perm": [
        "NotoSansOld Permic"
    ],
    "Phag": [
        "NotoSansPhagsPa"
    ],
    "Phli": [
        "NotoSansInscriptionalPahlavi"
    ],
    "Phlp": [
        "NotoSansPsalterPahlavi"
    ],
    "Phnx": [
        "NotoSansPhoenician"
    ],
    "Plrd": [
        "Shimenkan",
        "NotoSansMiao",
        "ShiShan"
    ],
    "Prti": [
        "NotoSansInscriptionalParthian"
    ],
    "Rjng": [
        "NotoSansRejang"
    ],
    "Runr": [
        "NotoSansRunic"
    ],
    "Samr": [
        "NotoSansSamaritan"
    ],
    "Sarb": [
        "NotoSansOldSouthArabian"
    ],
    "Saur": [
        "NotoSansSaurashtra"
    ],
    "Shui": [
        "NotoSansShuishu"
    ],
    "Sidd": [
        "NotoSansSiddham"
    ],
    "Sind": [
        "NotoSansKhudawadi"
    ],
    "Sinh": [
        "NotoSansSinhala",
        "NotoSerifSinhala"
    ],
    "Sora": [
        "NotoSansSora Sompeng"
    ],
    "Sylo": [
        "Surma",
        "NotoSansSylotiNagri"
    ],
    "Syrc": [
        "NotoSansSyriac"
    ],
    "Syrj": [
        "NotoSansSyriac"
    ],
    "Tagb": [
        "NotoSansTagbanwa"
    ],
    "Takr": [
        "NotoSansTakri"
    ],
    "Tale": [
        "NotoSansTaiLe"
    ],
    "Talu": [
        "Nokyung",
        "NotoSansNewTaiLue",
        "Dai Banna SIL"
    ],
    "Taml": [
        "TAML ThiruValluvar",
        "NotoSansTamil",
        "NotoSerifTamil"
    ],
    "Tang": [
        "NotoSansTangut"
    ],
    "Tavt": [
        "Tai Heritage Pro",
        "NotoSansTaiViet"
    ],
    "Telu": [
        "NotoSansTelugu",
        "NotoSerifTelugu"
    ],
    "Tfng-MA": [
        "Ebrima",
        "NotoSansTifinagh"
    ],
    "Tglg": [
        "NotoSansTagalog"
    ],
    "Thaa": [
        "NotoSansThaana"
    ],
    "Thai": [
        "NotoSansThai",
        "NotoSerifThai"
    ],
    "Tibt": [
        "NotoSansTibetan",
        "NotoSerifTibetan"
    ],
    "Tirh": [
        "NotoSansTirhuta"
    ],
    "Ugar": [
        "NotoSansUgaritic"
    ],
    "Vaii": [
        "Ebrima",
        "NotoSansVai"
    ],
    "Wara": [
        "NotoSansWarangCiti"
    ],
    "Xpeo": [
        "NotoSansOldPersian"
    ],
    "Xsux": [
        "NotoSansCuneiform"
    ],
    "Yiii": [
        "Nuosu SIL",
        "NotoSansYi"
    ]
};
